"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
var Type;
(function (Type) {
    // 将数据类型扩充了
    Type.C = {
        Array: { label: "array", value: "array" },
        Dict: { label: "dict", value: "dict" },
        BigInt: { label: "bigint", value: "bigint" },
        Int: { label: "int", value: "int" },
        Float: { label: "float", value: "float" },
        Bool: { label: "boolean", value: "boolean" },
        Symbol: { label: "symbol", value: "symbol" },
        Undefined: { label: "undefined", value: "undefined" },
        Null: { label: "null", value: "null" },
        Function: { label: "function", value: "function" },
        String: { label: "string", value: "string" },
    };
    function of(value) {
        switch (typeof value) {
            case "bigint":
                return "bigint";
            case "number":
                return Number.isInteger(value) ? "int" : "float";
            case "string":
                return "string";
            case "boolean":
                return "boolean";
            case "object":
                if (value === null) {
                    return "null";
                }
                else {
                    return Array.isArray(value) ? "array" : "dict";
                }
            case "symbol":
                return "symbol";
            case "undefined":
                return "undefined";
            case "function":
                return "function";
            default:
                return "undefined";
        }
    }
    Type.of = of;
    function is(value, type) {
        return Type.of(value) === type;
    }
    Type.is = is;
    function isArray(value) {
        return Type.is(value, "array");
    }
    Type.isArray = isArray;
    function isDict(value) {
        return Type.is(value, "dict");
    }
    Type.isDict = isDict;
    function isBigint(value) {
        return Type.is(value, "bigint");
    }
    Type.isBigint = isBigint;
    function isInt(value) {
        return Type.is(value, "int");
    }
    Type.isInt = isInt;
    function isFloat(value) {
        return Type.is(value, "float");
    }
    Type.isFloat = isFloat;
    function isBool(value) {
        return Type.is(value, "boolean");
    }
    Type.isBool = isBool;
    function isSymbol(value) {
        return Type.is(value, "symbol");
    }
    Type.isSymbol = isSymbol;
    function isUndefined(value) {
        return Type.is(value, "undefined");
    }
    Type.isUndefined = isUndefined;
    function isNull(value) {
        return Type.is(value, "null");
    }
    Type.isNull = isNull;
    function isFunction(value) {
        return Type.is(value, "function");
    }
    Type.isFunction = isFunction;
    function isString(value) {
        return Type.is(value, "string");
    }
    Type.isString = isString;
})(Type || (Type = {}));
exports.Type = Type;
//# sourceMappingURL=type.js.map